<template>
  <div
    v-if="isSlot"
    :class="{
      selected: selected,
      disabled: disabled,
    }"
    class="product-config-item"
    @click="$emit('click')"
  >
    <slot name="content"></slot>
  </div>
  <div
    v-else
    @click="$emit('click')"
    :class="{
      selected: selected,
      disabled: disabled,
    }"
    class="product-config-item title-medium"
  >
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    customClass() {
      if (this.disabled) {
        return 'product-config-item disabled'
      } else if (this.selected) {
        return 'product-config-item selected'
      }
      return 'product-config-item'
    },
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    selected: {
      type: Boolean,
      default: false,
    },

    isSlot: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>
// BaNANA Styles
.-is-bnn {
  .product-config-item{
	width: fit-content;
	height: fit-content;
    padding: 8px 16px;
    border-radius: 6px;
  }
  .product-config-item.selected {
    background-color: black;
    color: white;
	box-shadow: 0 0 0 2px black;
  }
}

// Studio7 Styles
.product-config-item
    height: 54px;
    border-radius: 8px;
    width: 100%
    display: flex
    padding: 1rem
    box-shadow: 0 0 0 1px $color-bnn-gray-light;
    cursor: pointer
    @media small
      background: white
    @media (hover: hover) and (pointer: fine)
      &:hover:not(.disabled):not(.selected)
        box-shadow: 0 0 0 1px $color-bnn-border;
        cursor: pointer


.product-config-item.disabled {
  color: #12121299;
  border: 1px dashed $color-bnn-gray-light;
  background: #f7f7f7b3;
  box-shadow: none;
  &.selected {
    color: #12121299;
    border: 1px dashed $color-border-btn-spec;
    background: #f7f7f7b3;
    box-shadow: none;
  }
  @media (hover: hover) and (pointer: fine){
    &:hover{
        color: #12121299;
        border: 1px dashed $color-border-btn-spec;
        background: #f7f7f7b3;
        box-shadow: none;
    }
  }
}

.product-config-item.selected {
  box-shadow: 0 0 0 2px $color-border-btn-spec;
}
</style>
